import './hero.sass';

export { default } from './hero';
